  /* ── Infusion Bundle: Mix & Match interactivity ── */
 document.addEventListener('DOMContentLoaded', () => {
    
    var section = document.getElementById('infusion-bundle');
    const anclaActual = window.location.hash;
    if(anclaActual == "#openCard")
    {
      openCartDrawer();
    }

    var cards     = section.querySelectorAll('.ib-protocol-card');
    var btnCreate = section.querySelector('.ib-btn-create');
    var totalEl   = section.querySelector('.ib-total');
    var countEl   = section.querySelector('.ib-item-count');
    var reloadOnCard = false;


    function formatMoney(n) {
      return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }

    document.addEventListener('click', (event) => {
    // .closest() busca hacia arriba en el DOM para ver si el elemento clickeado
    // o alguno de sus padres coincide con el selector.
        const el = event.target.closest('.js-mmcp-add-to-cart');

        if (el) {
            event.preventDefault(); 
            reloadOnCard=  true;
        }
    });

    waitForCartAdd().then((res) => {

      if(!reloadOnCard)
        return;
      
      window.location.hash = "#openCard";
      window.location.reload();

    });

    cards.forEach(function (card) {
      var qtyEl    = card.querySelector('.ib-qty-value');
      var btnMinus = card.querySelector('.ib-qty-minus');
      var btnPlus  = card.querySelector('.ib-qty-plus');
      var btnClear = card.querySelector('.ib-btn-clear');

      function setQty(n) {
        var val = Math.max(0, n);
        qtyEl.textContent = val;
        if (val > 0) {
          card.classList.add('ib-active');
          if (btnClear) btnClear.classList.add('ib-visible');
        } else {
          card.classList.remove('ib-active');
          if (btnClear) btnClear.classList.remove('ib-visible');
        }
        updateSummary();
      }

      if (btnPlus)  btnPlus.addEventListener('click',  function () { setQty(parseInt(qtyEl.textContent, 10) + 1); });
      if (btnMinus) btnMinus.addEventListener('click', function () { setQty(parseInt(qtyEl.textContent, 10) - 1); });
      if (btnClear) btnClear.addEventListener('click', function () { setQty(0); });
    });

    /* Create Custom Bundle — hook up to your cart logic here */
    if (btnCreate) {
      btnCreate.addEventListener('click', function () {
        var items = [];
        cards.forEach(function (card) {
          var qty = parseInt(card.querySelector('.ib-qty-value').textContent, 10) || 0;
          var pid = card.dataset.productId;
          if (qty > 0 && pid) {
            items.push({ id: pid, quantity: qty });
          }
        });
        /* Dispatch a custom event so you can intercept in your theme JS */
        section.dispatchEvent(new CustomEvent('ib:create-bundle', {
          bubbles: true,
          detail: { items: items }
        }));
        /* Fallback: add each item individually to Shopify cart */
        if (typeof fetch !== 'undefined') {
          var promises = items.map(function (item) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.id, quantity: item.quantity })
            });
          });
          Promise.all(promises).then(function () {
            window.location.href = '/cart';
          }).catch(function (err) {
            console.error('Bundle cart error:', err);
          });
        }
      });
    }

});


/**
 * Retorna una Promesa que se resuelve cuando se realiza 
 * una petición a cart/add.js (soporta fetch y XMLHttpRequest/jQuery).
 *
 * @returns {Promise<Response|XMLHttpRequest>}
 */
function waitForCartAdd() {
  return new Promise((resolve) => {
    // 1. Interceptar fetch (usado por Dawn, themes modernos y apps)
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const [resource] = args;
      const url = typeof resource === 'string' ? resource : resource?.url || '';

      if (url.includes('cart/add.js')) {
        // Ejecutamos la petición original y resolvemos cuando termine exitosamente
        return originalFetch.apply(this, args).then((response) => {
          // Clonamos la respuesta para no consumir el stream original del theme/app
          resolve(response.clone());
          return response;
        });
      }

      return originalFetch.apply(this, args);
    };

    // 2. Interceptar XMLHttpRequest (usado por temas antiguos o $.ajax de jQuery)
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this._url = url;
      return originalOpen.apply(this, [method, url, ...rest]);
    };

    XMLHttpRequest.prototype.send = function(...args) {
      if (typeof this._url === 'string' && this._url.includes('cart/add.js')) {
        this.addEventListener('load', () => {
          if (this.status >= 200 && this.status < 300) {
            resolve(this);
          }
        });
      }
      return originalSend.apply(this, args);
    };
  });
}